/**
 * Created by stonewang on 2017/8/21.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {Form, Input, Switch, Radio, Button, message, Upload, Row, Col, Icon} from 'antd';
import {DmsTab, RichEditor, SelectRange} from 'Components';
import {add, detail, modify} from '../../service/info';
import {getScope} from '../../service/channelFunc';
import {getOrgTree} from '../../service/product';
import {config} from 'Utils';
import {nameValidator} from '../../utils/regexp.js';
import './infodetail.css';
import {showSpin, hideSpin} from 'Utils';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class AddInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            infoId: parseInt(this.props.params.id, 10),
            detail: {},
            fileList: [],
            attachList: [],
            htmlContent: '',
            selectedKeys: [], //抄送范围的ID数组
            selectedNodes: [], //抄送范围的对象数组
            selectOptions: [],
            organizationOptions: [],
            choseType: 'area'
        };
        this.handleOk = this.handleOk.bind(this);
        this.openModal = this.openModal.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
        this.handleAttachChange = this.handleAttachChange.bind(this);
        this.deleteAttachment = this.deleteAttachment.bind(this);
    }

    getUploadFileData(file) {
        const response = file.response || {};
        if (response.status === false) {
            return null;
        }
        return response.data || {};
    }

    getAttachDownloadPath(filePath) {
        return filePath ? filePath.replace('getFile', 'getFileDown') : '';
    }

    getUploadFileId(file) {
        const data = this.getUploadFileData(file);
        if (data && data.id !== undefined && data.id !== null && data.id !== '') {
            return String(data.id);
        }
        if (file.id !== undefined && file.id !== null && file.id !== '') {
            return String(file.id);
        }
        return '';
    }

    componentDidMount() {
        const self = this;
        getOrgTree().then(res => {
            if (res.data && res.data.length > 0) {
                for (var i = 0; i < res.data.length; i++) {
                    if (i == 0) {
                        res.data[i].key = 10001;
                    } else {
                        res.data[i].key = res.data[i - 1].key + 1
                    }
                }
                self.setState({selectOptions: res.data});
            }
        });
        getScope().then(res => {
            if (res.data && res.data.length > 0) {
                self.setState({organizationOptions: res.data});
            }
        });
        if (this.state.infoId > 0) {
            detail(this.state.infoId).then(res => {
                if (res.status) {
                    const rangeText = res.data.rangeInfoList.map(x => x.name).join(';');
                    const attachList = (res.data.fileUrls || []).map((item, index) => ({
                        uid: String(item.id || `attach-${index}`),
                        id: item.id ? String(item.id) : '',
                        name: item.fileName,
                        fileName: item.fileName,
                        status: 'done',
                        url: item.filePath ? `${config.server}${this.getAttachDownloadPath(item.filePath)}` : '',
                    }));
                    self.setState({
                        detail: {...res.data, rangeText},
                        selectedKeys: res.data.rangeList.map(x => x.toString()),
                        selectedNodes: res.data.rangeInfoList,
                        htmlContent: res.data.content,
                        fileList: [
                            {
                                uid: -1,
                                name: '',
                                status: 'done',
                                id: res.data.picId,
                                url: res.data.filePath ? `${config.server}${res.data.filePath}` : '',
                                thumbUrl: res.data.filePath ? `${config.server}${res.data.filePath}` : ''
                            }
                        ],
                        attachList,
                    });
                }
            });
        }
    }

    cancelHandle() {
        hashHistory.goBack()
    }

    handleAttachChange(info) {
        const file = info.file;
        if (file.status === 'uploading') {
            return;
        }
        if (file.status === 'error') {
            message.error('附件上传失败');
            return;
        }
        if (file.status !== 'done') {
            return;
        }
        const data = this.getUploadFileData(file);
        if (!data || data.id === undefined || data.id === null || data.id === '') {
            message.error('附件上传失败');
            return;
        }
        const fileId = String(data.id);
        this.setState((prevState) => {
            const exists = prevState.attachList.some(item => String(item.id) === fileId);
            if (exists) {
                return null;
            }
            return {
                attachList: [...prevState.attachList, {
                    uid: fileId,
                    id: fileId,
                    name: data.fileName || file.name,
                    fileName: data.fileName || file.name,
                    status: 'done',
                    url: data.filePath ? `${config.server}${this.getAttachDownloadPath(data.filePath)}` : '',
                }],
            };
        });
    }

    deleteAttachment(index) {
        const attachList = [...this.state.attachList];
        attachList.splice(index, 1);
        this.setState({attachList});
    }

    submitHandle() {
        const {fileList, attachList, infoId, selectedKeys} = this.state;
        const {validateFields, getFieldsValue} = this.props.form;

        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            const data = {
                ...getFieldsValue(), //获取用户输入
            };
            data.rangeList = selectedKeys;
            data.isShow = data.isShow ? 1 : 0;
            if (fileList.length > 0 && fileList[0].id) {
                data.picId = fileList[0].id;
            } else if (fileList.length > 0 && fileList[0].response && fileList[0].response.data) {
                data.picId = fileList[0].response.data.id;
            } else {
                message.error('请设置列表展示图片');
                return null;
            }
            const attachIds = attachList.map(item => String(item.id)).filter(Boolean);
            data.fileId = attachIds.join(',');
            if (attachList.length > 0 && !data.fileId) {
                message.error('附件上传未完成，请等待上传成功后再保存');
                return null;
            }

            showSpin();
            if (infoId > 0) {
                modify({...data, id: infoId}).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack()
                })
            } else {
                add({...data}).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack()
                })
            }
        })
    }

    //发布范围相关
    handleOk = (keys, nodes) => {
        const rangeText = nodes.map(x => x.name).join(';');
        this.setState({
            visible: false,
            detail: {...this.state.detail, rangeText},
            selectedKeys: keys,
            selectedNodes: nodes,
        })
    }

    openModal() {
        this.selectRangModal.showModal()
    }

    render() {
        const {detail, fileList, attachList, infoId, selectedKeys, selectedNodes, htmlContent, choseType, selectOptions, organizationOptions} = this.state;
        const {getFieldDecorator} = this.props.form;
        const abbProps = {
            action: `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`,
            listType: 'picture',
            fileList: [...fileList],
            className: 'upload-img-only',
            onChange: (info) => {
                let fileList = info.fileList;
                fileList = fileList.slice(-1);
                fileList = fileList.map((file) => {
                    if (file.response) {
                        file.url = `${config.server}${file.response.data.filePath.split('?')[0]}?id=${file.response.data.id}`;
                        file.id = file.response.data.id;
                    }
                    return file;
                });
                fileList = fileList.filter((file) => {
                    if (file.response) {
                        return file.response.status;
                    }
                    return true;
                });

                this.setState({fileList});
            }
        };
        const attachmentProps = {
            action: `${config.server}/api/v1/dms/commonAttachUpload/mongoUpload`,
            showUploadList: false,
            multiple: true,
            onChange: this.handleAttachChange,
        };
        const attachHtml = (attachList || []).map((item, key) => (
            <div className="edit_upload_information" key={item.uid || key}>
                {item.url ? (
                    <a href={item.url} download={item.fileName || item.name} target="_blank" rel="noopener noreferrer">
                        {item.fileName || item.name}
                    </a>
                ) : (
                    <span>{item.fileName || item.name}</span>
                )}
                <i className="anticon anticon-delete" onClick={() => this.deleteAttachment(key)}/>
            </div>
        ));

        return <div className="dms-body">
            <DmsTab options={[`${infoId > 0 ? '编辑' : '新建'}帮助`]} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>
            <div className="dms-table-box">
                <div className="upload_add_pro" style={{marginBottom: '12px'}}>
                    <Upload {...abbProps}>
                        <span className="ti">列表展示图<font>*</font></span>
                        <Button>选择图片文件</Button>
                        <span className="hint">建议图片大小 : 118x95px <span
                            style={{color: '#d61418'}}>(只能保存一张图片)</span></span>
                    </Upload>
                </div>
                <div className="upload_add_pro info-attach-upload" style={{marginBottom: '12px'}}>
                    <Upload {...attachmentProps}>
                        <span className="ti">附件</span>
                        <Button><Icon type="upload"/> 上传附件</Button>
                        <span className="hint">支持上传多个附件文件</span>
                    </Upload>
                    {attachHtml}
                </div>
                <Form layout="horizontal">
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="标题：" hasFeedback>
                                {getFieldDecorator('title', {
                                    initialValue: detail.title || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入标题',
                                            min: 1,
                                            max: 128
                                        }
                                    ],
                                })(<Input placeholder="请输入标题"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="发布范围：">
                                <Input placeholder="请选择发布范围" value={detail.rangeText} onClick={this.openModal}/>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="关键字：" hasFeedback>
                                {getFieldDecorator('keyword', {
                                    initialValue: detail.keyword || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入关键字'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ],
                                })(<Input placeholder=""/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="评论权限：" hasFeedback>
                                {getFieldDecorator('isComment', {
                                    initialValue: detail.isComment !== '' ? detail.isComment + '' : '',
                                })(
                                    <RadioGroup>
                                        <Radio value="1">可评论</Radio>
                                        <Radio value="0">不可评论</Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="首页头条：" hasFeedback>
                                {getFieldDecorator('isShow', {
                                    valuePropName: 'checked',
                                    initialValue: detail.isShow ? true : false,
                                })(<Switch checkedChildren="是" unCheckedChildren="否"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <FormItem label="正文：" hasFeedback>
                            {getFieldDecorator('content', {
                                initialValue: htmlContent || '',
                                valuePropName: 'htmlContent',
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正文'
                                    },
                                ],
                            })(<RichEditor/>)}
                        </FormItem>
                    </Row>
                </Form>
            </div>

            <SelectRange ref={(node) => {
                this.selectRangModal = node;
            }}
                         keys={selectedKeys}
                         nodes={selectedNodes}
                         options={choseType === 'area' ? selectOptions : organizationOptions}
                         checked={false}
                         chose={this.chose}
                         onOk={this.handleOk}/>

        </div>
    }
}

export default Form.create()(AddInfo)



// WEBPACK FOOTER //
// ./src/routes/info/add.js